import Vue from "vue";
import VueRouter from "vue-router";
import BasicLayout from "@/components/basic-layout/index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: BasicLayout,
    children: [
      {
        path: "",
        name: "Home",
        component: () => import("@/views/home-view/index.vue"),
      },
      {
        path: "session-:id",
        name: "Session",
        component: () => import("@/views/session-view/index.vue"),
      },
      {
        path: "prompt",
        name: "Prompt",
        component: () => import("@/views/prompt-view/index.vue"),
      },
      {
        path: "recharge",
        name: "Recharge",
        component: () => import("@/views/recharge-view/index.vue"),
      },
    ],
  },
  { path: "*", redirect: "/" },
];

const router = new VueRouter({
  routes,
});

export default router;
